import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {Image} from '@app/components/Image';
import {useLocation} from '@app/hooks/use-location';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useUser} from '@deezer/react-user';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {useAuthLink} from '@app/hooks/use-link';

export const SongcatcherHero: FunctionComponent = () => {
	const {t} = useTranslation();
	const {getDeezerUrl} = useLocation();
	const [user] = useUser();
	const {getRegistrationLink} = useAuthLink();

	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading
						as="h1"
						dangerouslySetInnerHTML={{
							__html: t(
								'songcatcherlandingpage_title_identifymusicinonetap_standalone-web',
								{
									ns: 'songcatcher',
								},
							),
						}}
					/>
					<LandingParagraph>
						{t(
							'songcatcherlandingpage_text_identifymusicinonetap_standalone-web',
							{ns: 'songcatcher'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'signup'}}
						href={
							user?.isConnected()
								? getDeezerUrl('/open_app')
								: getRegistrationLink()
						}
						isMain
					>
						{t('generic_action_signupnow_standalone-web', {ns: 'common'})}
					</LandingButtonLink>
				</>
			}
			image={
				<Image
					h={{base: '200px', md: '100%'}}
					quality={75}
					alt={t('metatag_text_identifymusicinonetap_standalone-web', {
						ns: 'common',
					})}
					src="c2ff533e85071cc903f311881fa93567.png"
					aspectRatio="1440/420"
					objectFit={{base: 'cover', sm: 'contain'}}
					priority
				/>
			}
		/>
	);
};
